/*
 *
 * ClassesDetail actions
 *
 */

import {
  FLUSH_STATE,
  LOAD_CLASS,
  LOAD_CLASS_SUCCESS,
  LOAD_CLASS_ERROR
} from './constants';

export function flushState() {
  return {
    type: FLUSH_STATE,
  };
}

/**
 * Load the class, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_CLASSS */

export function loadClass(id) {
  return {
    type: LOAD_CLASS,
    id,
  };
}

/**
 * Dispatched when the loadClass are loaded by the request saga
 *
 * @param  {array} Class true for class
 *
 * @return {object}      An action object with a type of LOAD_CLASSS_SUCCESS passing the class */

export function loadClassSuccess(itemData) {
  return {
    type: LOAD_CLASS_SUCCESS,
    itemData,
  };
}

/**
 * Dispatched when loading the loadClasss fails
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_CLASSS_ERROR passing the error */

export function loadClassError(error) {
  return {
    type: LOAD_CLASS_ERROR,
    error,
  };
}